import RangeDatePicker from "./RangeDatePicker";
import {Alert, Card} from "flowbite-react";
import React, {useContext, useEffect} from "react";
import {vendorGetChartData} from "../../../services/api/dashboard";
import VendorDashboardChart from "./Chart";
import {AuthContext} from "../../../context/AuthContext";
import Tooltip from "../../Common/Tooltip";
import {InfoCircle, QuestionCircle} from "flowbite-react-icons/outline";
import {moment} from "../../../services/moment-extensions";
import NO_LOGO from "../../../images/svg/vendor/building.svg";
import {VENDOR_CHART_IS_ESSENTIAL} from "../../../services/constants/VendorDashboardPackages";

const CDN = process.env.REACT_APP_RESIZABLE;

const ChartBlock = ({title, subTitle, apiRoute, blockTypeTitle, tooltipText, seriesLabels, skipDivider = false}) => {
    const [chartData, setChartData] = React.useState(null);
    const [chartOriginalData, setChartOriginalData] = React.useState(null);
    const [chartTopData, setChartTopData] = React.useState([]);
    const [chartRange, setChartRange] = React.useState(null);
    const [isLoaded, setIsLoaded] = React.useState(false);
    const {company} = useContext(AuthContext);

    const groupChartDataByPeriod = (data) => {

        if (!data) return [];

        if (chartRange.mode === 'week') {
            return data.reduce((acc, item) => {
                const week = moment(item.date).startOf('week').format('YYYY-MM-DD');
                const existingWeek = acc.find((accItem) => accItem.date === week);
                if (existingWeek) {
                    existingWeek.vendor_data += item.vendor_data;
                    existingWeek.others_data += item.others_data;
                } else {
                    acc.push({
                        date: week,
                        vendor_data: item.vendor_data,
                        others_data: item.others_data
                    });
                }
                return acc;
            }, []);
        }


        if (chartRange.mode === 'month') {
            return data.reduce((acc, item) => {
                const month = moment(item.date).startOf('month').format('YYYY-MM-DD');
                const monthName = moment(item.date).startOf('month').format('MMM YYYY');

                const existingMonth = acc.find((accItem) => accItem.checkMonth === month);
                if (existingMonth) {
                    existingMonth.vendor_data += item.vendor_data;
                    existingMonth.others_data += item.others_data;
                } else {
                    //show only month and year MM-YYYY in date
                    acc.push({
                        date: monthName,
                        checkMonth: month,
                        vendor_data: item.vendor_data,
                        others_data: item.others_data
                    });

                }
                return acc;
            }, []);
        }
    }

    const getChatData = async () => {
        try {
            setIsLoaded(false);
            setChartOriginalData(null);
            setChartData(null);
            setChartTopData(null);
            const {
                data,
                ...topData
            } = await vendorGetChartData(apiRoute, moment(chartRange.from).toApiDateTime(), moment(chartRange.to).endOf('day').toApiDateTime());
            setChartOriginalData(data);
            setChartData(groupChartDataByPeriod(data))
            setChartTopData(topData[Object.keys(topData)[0]]);
            setIsLoaded(true);
        } catch (e) {
            console.log(e)
            setIsLoaded(true);
        }
    }

    useEffect(() => {
            if (chartRange)
                getChatData().catch(e => console.log(e));
        },
        /* eslint-disable react-hooks/exhaustive-deps */
        [chartRange?.from, chartRange?.to]);

    useEffect(() => {
            if (chartRange)
                setChartData(groupChartDataByPeriod(chartOriginalData))
        },
        /* eslint-disable react-hooks/exhaustive-deps */
        [chartRange?.mode]);


    return <div className={"flex flex-col sl-gap-10 container sl-m-auto "}>
        <div>
            <div className={"sl-text-left sl-pb-8 flex flex-row justify-between"}>
                <div>
                 <span
                     className={"sl-text-left sl-text-gray-900 sl-text-xl sl-font-semibold flex flex-row sl-gap-2"}>{title}
                     <Tooltip content={tooltipText}><QuestionCircle color={"#98A2B3"} size={15}/></Tooltip></span>
                </div>
                <div>
                    <RangeDatePicker setChartRange={setChartRange}/>
                </div>
            </div>
            <VendorDashboardChart
                isLoaded={isLoaded}
                seriesLabels={seriesLabels}
                mode={chartRange?.mode}
                chartData={chartData}
                essentialsDate={company?.[VENDOR_CHART_IS_ESSENTIAL] ? company['package_activation_date'] : null}/>
        </div>

        <div>
            <div className={"sl-text-left sl-pb-8 flex flex-row justify-between"}>
                    <span
                        className={"sl-text-left sl-text-gray-900 sl-text-xl sl-font-semibold"}>

                        {subTitle}</span>
            </div>


            <div className=" items-start sm:flex sl-gap-8  ">

                {!isLoaded && [1, 2, 3].map((i, index) => <div
                    key={index}
                    className={"flex flex-col items-start sl-gap-2"}

                >
                    <div
                        className={"skeleton-loader"}
                        style={{
                            "width": "150px",
                            "height": "86px",
                            "borderRadius": "8px",
                            "background": "#EAECF0"
                        }}
                    />
                    <div style={{
                        "background": "#EAECF0",
                        width: '60px',
                        height: '12px'
                    }}>
                    </div>
                </div>)}

                {isLoaded && !chartTopData?.length &&
                    <Alert color="light" className={"sl-bg-gray-25 sl-border-gray-300 border-solid sl-border sl-w-full"}
                           icon={InfoCircle}>
                        <span>There are no broker {blockTypeTitle} for the specific date.</span> </Alert>}

                {chartTopData?.map((broker, index) =>
                    <div
                        key={index}
                        className={"flex flex-col items-center justify-center"}
                    >
                        <Card style={{width: '150px'}} className={" sl-mb-1 flex items-center"}>

                            {!broker.logo && <img src={NO_LOGO} alt={broker.name} width={40} height={40}/>}

                            {broker.logo && <img src={`${CDN}/${broker.logo}`}
                                                 alt={broker.name}
                                                 style={{height: '45px', objectFit: 'contain'}}
                            />}
                        </Card>
                        <span
                            className={"sl-text-gray-700 sl-text-center sl-font-semibold sl-text-sm"}>{broker.name}</span>
                    </div>
                )}
            </div>

        </div>
        {!skipDivider && <hr/>}
    </div>

}

export default ChartBlock;
